import store from '@/store'
import { ENV_KEY } from '@/constants/env'
import * as RouterPage from '@/constants/route-page'
import HiddenHeaderLayout from '@/layouts/HiddenHeaderLayout.vue'
// import { getDevice, DEVICE } from '@/utils/helper.js'

export default [
  {
    path: RouterPage.EC_LINE001,
    name: 'EC_LINE001',
    component: () => import(/* webpackChunkName: "EC_LINE001" */ '@/views/EC_LINE001.vue'),
  },
  {
    path: RouterPage.EC_LINE002,
    name: 'EC_LINE002',
    props: true,
    component: () => import(/* webpackChunkName: "EC_LINE002" */ '@/views/EC_LINE002.vue'),
  },
  {
    path: RouterPage.EC_LINE003,
    name: 'EC_LINE003',
    component: () => import(/* webpackChunkName: "EC_LINE003" */ '@/views/EC_LINE003.vue'),
  },
  {
    path: RouterPage.EC_LINE029_001,
    name: 'EC_LINE029_001',
    component: () => import(/* webpackChunkName: "EC_LINE029_001" */ '@/views/EC_LINE029_001.vue'),
  },
  {
    path: RouterPage.EC_LINE029_002,
    name: 'EC_LINE029_002',
    component: () => import(/* webpackChunkName: "EC_LINE029_002" */ '@/views/EC_LINE029_002.vue'),
  },
  {
    path: RouterPage.EC_LINE004_001,
    alias: RouterPage.EC_LINE004_002,
    name: 'EC_LINE004',
    component: () => import(/* webpackChunkName: "LINE-WEB004" */ '@/views/EC_LINE004.vue'),
    props: true,
  },
  {
    // path: RouterPage.EC_LINE005,
    path: RouterPage.EC_LINE005_001,
    alias: RouterPage.EC_LINE005_002,
    name: 'EC_LINE005',
    props: true,
    component: () => import(/* webpackChunkName: "LINE_WEB005" */ '@/views/EC_LINE005.vue'),
  },
  {
    path: RouterPage.EC_LINE009,
    name: 'EC_LINE009',
    component: () => import(/* webpackChunkName: "EC_LINE009" */ '@/views/EC_LINE009.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: RouterPage.EC_LINE010,
    name: 'EC_LINE010',
    component: () => import(/* webpackChunkName: "EC_LINE010" */ '@/views/EC_LINE010.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: RouterPage.EC_LINE027,
    name: 'EC_LINE027',
    component: () => import(/* webpackChunkName: "EC_LINE011_LIST" */ '@/views/EC_LINE027.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: RouterPage.EC_LINE011_NEW,
    name: 'EC_LINE011_NEW',
    component: () => import(/* webpackChunkName: "EC_LINE011_NEW" */ '@/views/EC_LINE011.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: RouterPage.EC_LINE011_UPDATE,
    name: 'EC_LINE011_UPDATE',
    component: () => import(/* webpackChunkName: "EC_LINE011_UPDATE" */ '@/views/EC_LINE011.vue'),
    props: true,
    meta: {
      auth: true,
    },
  },
  {
    path: RouterPage.EC_LINE012,
    name: 'EC_LINE012',
    component: () => import(/* webpackChunkName: "EC_LINE012" */ '@/views/EC_LINE012.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: RouterPage.EC_LINE013_NEW,
    name: 'EC_LINE013_NEW',
    component: () => import(/* webpackChunkName: "EC_LINE013" */ '@/views/EC_LINE013.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: RouterPage.EC_LINE013_EDIT,
    name: 'EC_LINE013_EDIT',
    props: true,
    component: () => import(/* webpackChunkName: "EC_LINE013" */ '@/views/EC_LINE013.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: RouterPage.EC_LINE014,
    name: 'EC_LINE014',
    component: () => import(/* webpackChunkName: "EC_LINE014" */ '@/views/EC_LINE014.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: RouterPage.EC_LINE015,
    name: 'EC_LINE015',
    component: () => import(/* webpackChunkName: "EC_LINE015" */ '@/views/EC_LINE015.vue'),
    meta: {
      auth: true,
    },
    props: true,
  },
  {
    path: RouterPage.EC_LINE016,
    name: 'EC_LINE016',
    component: () => import(/* webpackChunkName: "EC_LINE016" */ '@/views/EC_LINE016.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: RouterPage.EC_LINE017,
    name: 'EC_LINE017',
    props: true,
    component: () => import(/* webpackChunkName: "EC_LINE017" */ '@/views/EC_LINE017.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: RouterPage.EC_LINE028,
    name: 'EC_LINE028',
    props: true,
    component: () => import(/* webpackChunkName: "EC_LINE028" */ '@/views/EC_LINE028.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: RouterPage.EC_LINE020,
    alias: [RouterPage.EC_LINE021, RouterPage.EC_LINE022],
    name: 'EC_LINE020_021_022',
    component: () => import(/* webpackChunkName: "EC_LINE020_021_022" */ '@/views/EC_LINE020_021_022.vue'),
  },
  {
    path: RouterPage.EC_LINE018,
    name: 'EC_LINE018',
    component: () => import(/* webpackChunkName: "EC_LINE018" */ '@/views/EC_LINE018.vue'),
  },
  {
    path: RouterPage.EC_LINE023,
    name: 'EC_LINE023',
    // component: () => import(/* webpackChunkName: "EC_LINE023" */ '@/views/EC_LINE023.vue'),
    // eslint-disable-next-line no-unused-vars
    beforeEnter: (to, from, next) => {
      window.location.href = `${store.getters['env/GET_KEY'](ENV_KEY.BASE_URL)}/contents/faq.html`
    },
  },
  {
    path: RouterPage.EC_LINE026,
    name: 'EC_LINE026',
    // component: () => import(/* webpackChunkName: "EC_LINE026" */ '@/views/EC_LINE026.vue'),
    // eslint-disable-next-line no-unused-vars
    beforeEnter: (to, from, next) => {
      window.location.href = `${store.getters['env/GET_KEY'](ENV_KEY.BASE_URL)}/contents/company.html`
    },
  },
  {
    path: '/sitemaps',
    name: 'SiteMaps',
    component: () => import(/* webpackChunkName: "SiteMaps" */ '@/views/SiteMaps.vue'),
    meta: {
      auth: false,
    },
  },
  {
    path: RouterPage.EC_LINE024,
    name: 'EC_LINE024',
    // component: () => import(/* webpackChunkName: "EC_LINE024" */ '@/views/EC_LINE024.vue'),
    // eslint-disable-next-line no-unused-vars
    beforeEnter: (to, from, next) => {
      window.location.href = `${store.getters['env/GET_KEY'](ENV_KEY.BASE_URL)}/contents/defrayal.html`
    },
  },
  {
    path: RouterPage.EC_LINE025,
    name: 'EC_LINE025',
    // component: () => import(/* webpackChunkName: "EC_LINE025" */ '@/views/EC_LINE025.vue'),
    // eslint-disable-next-line no-unused-vars
    beforeEnter: (to, from, next) => {
      window.location.href = `${store.getters['env/GET_KEY'](ENV_KEY.BASE_URL)}/contents/privacy.html`
    },
  },
  {
    path: RouterPage.EC_LINE030,
    name: 'EC_LINE030',
    // component: () => import(/* webpackChunkName: "EC_LINE025" */ '@/views/EC_LINE025.vue'),
    // eslint-disable-next-line no-unused-vars
    beforeEnter: (to, from, next) => {
      window.location.href = `${store.getters['env/GET_KEY'](ENV_KEY.BASE_URL)}/contents/terms-of-use.html`
    },
  },
  {
    path: RouterPage.EC_LINE031,
    name: 'EC_LINE031',
    component: () => import(/* webpackChunkName: "EC_LINE031" */ '@/views/EC_LINE031.vue'),
  },
  {
    path: RouterPage.EC_LINE032,
    name: 'EC_LINE032',
    component: () => import(/* webpackChunkName: "EC_LINE032" */ '@/views/EC_LINE032.vue'),
  },
  {
    path: RouterPage.EC_LINE033,
    name: 'EC_LINE033',
    component: () => import(/* webpackChunkName: "EC_LINE033" */ '@/views/EC_LINE033.vue'),
  },
  {
    path: RouterPage.EC_LINE034,
    name: 'EC_LINE034',
    component: () => import(/* webpackChunkName: "EC_LINE034" */ '@/views/EC_LINE034.vue'),
  },
  {
    path: RouterPage.EC_LINE035,
    name: 'EC_LINE035',
    component: () => import(/* webpackChunkName: "EC_LINE035" */ '@/views/EC_LINE035.vue'),
  },
  {
    path: RouterPage.EC_LINE036,
    name: 'EC_LINE036',
    component: () => import(/* webpackChunkName: "EC_LINE036" */ '@/views/EC_LINE036.vue'),
  },
  {
    path: RouterPage.EC_LINE037,
    name: 'EC_LINE037',
    component: () => import(/* webpackChunkName: "EC_LINE037" */ '@/views/EC_LINE037.vue'),
  },
  {
    path: RouterPage.EC_LINE038,
    name: 'EC_LINE038',
    // eslint-disable-next-line no-unused-vars
    beforeEnter: (to, from, next) => {
      window.location.href = `${store.getters['env/GET_KEY'](ENV_KEY.BASE_URL)}/contents/customer_rank.html`
    },
  },
  {
    path: RouterPage.CALLBACK,
    name: 'Callback',
    component: () => import(/* webpackChunkName: "SiteMaps" */ '@/views/Callback.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: RouterPage.EC_LINE039,
    name: 'EC_LINE039',
    component: () => import(/* webpackChunkName: "EC_LINE039" */ '@/views/EC_LINE039.vue'),
  },
  {
    path: RouterPage.EC_LINE040,
    name: 'EC_LINE040',
    component: () => import(/* webpackChunkName: "EC_LINE040" */ '@/views/EC_LINE040.vue'),
  },
  {
    path: RouterPage.LINE_SUBSCRIBE,
    name: 'LineSubscribe',
    component: () => import(/* webpackChunkName: "LineSubscribe" */ '@/views/LineSubscribe.vue'),
  },
  {
    path: RouterPage.EC_LINE041,
    name: 'EC_LINE041',
    component: () => import(/* webpackChunkName: "EC_LINE041" */ '@/views/EC_LINE041.vue'),
    meta: { layout: HiddenHeaderLayout },
  },
  {
    path: RouterPage.EC_LINE042,
    name: 'EC_LINE042',
    component: () => import(/* webpackChunkName: "EC_LINE042" */ '@/views/EC_LINE042.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: RouterPage.PAGE_NOT_FOUND,
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
  },
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
  },
]
